module.exports = __webpack_public_path__ + "img/hohlschnitt_rot_candy.a2405a72.jpg";